export const stock = {
	title: "STOCK",
	fields: {
		isStockable: {
			label: "Stockable product?",
			placeholder: "Yes",
			tooltip:
				"Stockable products are those that are stored in inventory until they are sold or used.",
			options: {
				yes: "Yes",
				no: "No",
			},
		},
		stockControlledBy: {
			label: "Stock controlled by:",
			placeholder: "Units",
			options: {
				gram: "Grams",
				kilogram: "Kilograms",
				liter: "Liters",
				milliliter: "Milliliters",
				unit: "Units",
			},
		},
		conversionRule: {
			label: "Conversion rule",
			tooltip:
				"Define how units of sale convert to units of stock. Ex: 1 bottle = 1 liter",
			unitLabel: "1 unit",
			equivalentTo: "equals:",
		},
		conversionQuantity: {
			label: "Quantity",
			placeholder: "750",
		},
		conversionUnit: {
			label: "Unit of measure",
			placeholder: "Milliliters",
			options: {
				gram: "Grams",
				kilogram: "Kilograms",
				liter: "Liters",
				milliliter: "Milliliters",
			},
		},
	},
	messages: {
		nonStockableWarning:
			"Non-stockable products <strong>will not appear in stock reports</strong>",
	},
};
